export default class $t {
  constructor(t) {
    this.productId = t;
  }
  Jl(t) {
    return null == this.productId || t[0] === this.productId;
  }
  static fromJson(t) {
    return new $t(t ? t.product_id : null);
  }
  ss() {
    return this.productId;
  }
}
